import Vue from 'vue';
import Router from 'vue-router';

//  Main Pages
import Home from './views/Home.vue';
import Products from './views/Products.vue';
import Product from './views/Product.vue';
import Page404 from './views/404.vue';

import MainNavbar from './layout/MainNavbar.vue';
import MainFooter from './layout/MainFooter.vue';

Vue.use(Router);

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Home',
      components: { default: Home, header: MainNavbar, footer: MainFooter },
      props: {
        header: { navbarTransparent: false },
      },
    },
    {
      path: '/products',
      name: 'Products',
      components: {
        default: Products,
        header: MainNavbar,
        footer: MainFooter,
      },
      props: {
        header: { colorOnScroll: 300, navbarTransparent: true },
      },
    },
    {
      path: '/product/*',
      name: 'Product',
      components: {
        default: Product,
        header: MainNavbar,
        footer: MainFooter,
      },
      props: {
        header: { colorOnScroll: 400, navbarTransparent: true },
      },
    },
    {
      path: '*',
      name: '404',
      components: { default: Page404, header: MainNavbar, footer: MainFooter },
      props: {
        header: { colorOnScroll: 400, navbarTransparent: true },
      },
    },
  ],
  scrollBehavior: (to, from, savedPosition) => {
    if (savedPosition) {
      return savedPosition;
    } if (to.hash) {
      return { selector: to.hash };
    }
    return { x: 0, y: 0 };
  },
});
